// Standalone has no host to init this app's own MF container, so registerRemotes() throws RUNTIME-009; be our own host.
export async function initOwnContainer() {
  // Built at runtime so Vite's import-analysis does not try to resolve it; the federation plugin's dev middleware serves remoteEntry.js here too.
  const remoteEntryUrl = new URL('/remoteEntry.js', window.location.origin).href;
  const remoteEntry = await import(/* @vite-ignore */ remoteEntryUrl);
  await remoteEntry.init();
}
